import { useTranslation } from 'react-i18next';
import { ReactComponent as ArrowLeftIcon } from 'assets/icons/arrow-left.svg';
import Button from 'components/Button/Button';
import { BUTTON_VARIANT } from 'constants/interfaces';

import { sliderToRealValueCoefficient } from '../../../../utils/helpers';
import InsightsDashboardSlider from './InsightsDashboardSlider';

import type { IInsightsDashboardCoefficientsProps } from '../interfaces/IInsightsDashboardCoefficientsProps';

import styles from '../scss/MAInsightsDashboard.module.scss';

function InsightsDashboardCoefficients({
  control,
  coefficientData,
  fields,
  update,
  onSaveCoefficients,
  onHandleBack,
  onHandleReset,
  isSetImpactLoading,
}: IInsightsDashboardCoefficientsProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <div className={styles.backNavigation}>
        <Button
          title={t('common.back')}
          startIcon={<ArrowLeftIcon />}
          variant={BUTTON_VARIANT.ghost}
          className={styles.backButton}
          onClick={() => onHandleBack()}
        />
      </div>
      <div className={styles.titleWrapper}>
        <p>{t('materialityAssessment.settingWeighting')}</p>
        <Button
          title={t('materialityAssessment.resetCoefficients')}
          variant={BUTTON_VARIANT.cancel}
          className={styles.button}
          onClick={() => onHandleReset(true)}
        />
      </div>
      <div className={styles.rootContainer}>
        <InsightsDashboardSlider
          control={control}
          coefficientData={coefficientData}
          fields={fields}
          onSliderChange={(index, val, field, sliderField) => {
            const real = val === -10 ? 0.1 : sliderToRealValueCoefficient(+val);
            sliderField.onChange(real);
            update(index, { id: field.id, impact: real });
          }}
        />
        <div className={styles.buttonWrapper}>
          <Button
            title={t('common.save')}
            className={styles.button}
            isLoading={isSetImpactLoading}
            onClick={onSaveCoefficients}
          />
        </div>
      </div>
    </div>
  );
}

export default InsightsDashboardCoefficients;
